/* Discovery Quiz - Shopify standalone (vanilla JS, no deps)
   4-step "Find Your Mac" wizard: Who > Job > Why > Budget
   Calls lc-next.pages.dev for inventory-count + recommend APIs
   Redirects to Shopify search/collection with recommended slugs */
(function(){
  if(window.__discoveryLoaded) return;
  window.__discoveryLoaded=true;

  var API='https://lc-next.pages.dev/api';
  var PINK='#FF2D95';
  var SHOP='/collections/all';

  var SLUG_TO_HANDLE={
    'mba-m1-13':'mba-m1-13','mba-m1-13-v2':'mba-m1-13-v2','mba-m1-13-v3':'mba-m1-13-v3','mba-m1-13-v4':'mba-m1-13-v4',
    'mba-m2-13':'mba-m2-13','mba-m2-13-v2':'mba-m2-13-v2','mba-m2-13-v3':'mba-m2-13-v3',
    'mba-m3-13':'mba-m3-13','mba-m3-13-v2':'mba-m3-13-v2','mba-m3-13-v3':'mba-m3-13-v3','mba-m3-13-v4':'mba-m3-13-v4',
    'mba-m3-15':'mba-m3-15','mba-m3-15-v3':'mba-m3-15-v3','mba-m3-15-v4':'mba-m3-15-v4',
    'mbp-m1p-14':'mbp-m1p-14','mbp-m1p-14-v2':'mbp-m1p-14-v2','mbp-m1p-14-v3':'mbp-m1p-14-v3','mbp-m1p-14-v4':'mbp-m1p-14-v4',
    'mbp-m2p-14':'mbp-m2p-14','mbp-m2p-14-v2':'mbp-m2p-14-v2','mbp-m2p-14-v3':'mbp-m2p-14-v3','mbp-m2p-14-v4':'mbp-m2p-14-v4',
    'mbp-m3p-14':'mbp-m3p-14','mbp-m3p-14-v2':'mbp-m3p-14-v2','mbp-m3p-14-v3':'mbp-m3p-14-v3','mbp-m3p-14-v4':'mbp-m3p-14-v4',
    'mbp-m2m-16':'mbp-m2m-16','mbp-m2m-16-v2':'mbp-m2m-16-v2','mbp-m2m-16-v3':'mbp-m2m-16-v3',
    'imac-m1-24':'imac-m1-24','imac-m1-24-v2':'imac-m1-24-v2','imac-m1-24-v3':'imac-m1-24-v3','imac-m1-24-v4':'imac-m1-24-v4',
    'imac-m3-24':'imac-m3-24','imac-m3-24-v2':'imac-m3-24-v2','imac-m3-24-v3':'imac-m3-24-v3',
    'mini-m2':'mini-m2','mini-m2-v2':'mini-m2-v2','mini-m2p':'mini-m2p'
  };

  // Step data
  var STEP_FOR_WHOM=[
    {value:'me',label:'Me',sub:"I'll be the daily driver"},
    {value:'kid',label:'A kid',sub:'School, games, or first device'},
    {value:'gift',label:'A gift',sub:'For someone special'},
    {value:'business',label:'My business',sub:'Work setup for the team'},
    {value:'browsing',label:'Just looking',sub:"Show me what's good"}
  ];

  function stepMainJob(whom){
    if(whom==='kid') return [
      {value:'school',label:'Schoolwork',sub:'Homework, classes, writing',family:'laptop'},
      {value:'gaming',label:'Gaming',sub:'Minecraft, Roblox, casual',family:'laptop'},
      {value:'browsing',label:'First device',sub:'Learning the ropes',family:'laptop'},
      {value:'video editing',label:'Drawing + video',sub:'YouTube, art, TikTok',family:'laptop'}
    ];
    if(whom==='business') return [
      {value:'writing',label:'Email + docs',sub:'Office, Zoom, browser',family:'laptop'},
      {value:'design',label:'Creative work',sub:'Photo, video, design',family:'laptop'},
      {value:'browsing',label:'POS / register',sub:'Selling, scanning, tracking',family:'desktop'},
      {value:'family',label:'Multi-user',sub:'Shared by my team',family:'desktop'}
    ];
    return [
      {value:'writing',label:'Work + browsing',sub:'Email, web, light apps',family:'laptop'},
      {value:'video editing',label:'Creative apps',sub:'Video, photo, design',family:'laptop'},
      {value:'school',label:'School',sub:'Notes, classes, papers',family:'laptop'},
      {value:'gaming',label:'Gaming',sub:'Steam, casual, light gaming',family:'laptop'}
    ];
  }

  var STEP_DRIVER=[
    {value:'broken',label:'The old one is dying',sub:"Cracked, slow, won't hold a charge"},
    {value:'outgrew',label:'I outgrew it',sub:'Doing more than it can handle'},
    {value:'gift_deadline',label:'Gift / deadline',sub:'Birthday, graduation, holiday'},
    {value:'first_device',label:'First Mac ever',sub:'Switching from Windows / Chromebook'},
    {value:'just_curious',label:'Just looking',sub:'No rush - exploring options'}
  ];

  var STEP_LABELS=['Who','Job','Why','Budget'];
  var stepOrder=['forWhom','mainJob','driver','budget'];

  // State
  var currentStep='forWhom';
  var forWhom=null;
  var mainJob=null;
  var jobFamily=null;
  var driver=null;
  var budgetMin=300;
  var budgetMax=1500;
  var inventoryCount=null;
  var submitting=false;
  var fetchController=null;

  // --- DOM ---
  var root=document.getElementById('discovery-root');
  if(!root) return;

  var style=document.createElement('style');
  style.textContent='\
    #discovery-root{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;background:#000;color:#fff;min-height:80vh;padding:0}\
    .dq-progress{height:4px;background:rgba(255,255,255,.05);overflow:hidden}\
    .dq-progress-bar{height:100%;background:'+PINK+';transition:width .4s ease-out}\
    .dq-pills{display:flex;align-items:center;justify-content:center;gap:8px;padding:16px 20px}\
    .dq-pill{display:flex;align-items:center;gap:6px;font-size:12px;font-weight:600;padding:4px 12px;border-radius:999px;transition:all .2s}\
    .dq-pill.done{background:rgba(255,45,149,.2);color:'+PINK+';border:1px solid rgba(255,45,149,.3)}\
    .dq-pill.active{background:'+PINK+';color:#fff;border:1px solid '+PINK+'}\
    .dq-pill.future{background:rgba(255,255,255,.05);color:#888;border:1px solid rgba(255,255,255,.08)}\
    .dq-pill-sep{width:16px;height:1px;background:rgba(255,255,255,.1)}\
    .dq-content{max-width:960px;margin:0 auto;padding:0 20px 40px}\
    .dq-header{text-align:center;margin-bottom:32px}\
    .dq-header h2{font-size:clamp(20px,4vw,30px);font-weight:900;color:#fff;letter-spacing:-.02em;margin:0 0 8px}\
    .dq-header p{color:#888;font-size:14px;margin:0}\
    .dq-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:12px}\
    @media(min-width:768px){.dq-grid{grid-template-columns:repeat(4,1fr)}}\
    .dq-card{background:#1a1a1a;border:2px solid transparent;border-radius:16px;padding:16px;cursor:pointer;text-align:left;transition:all .15s;position:relative}\
    .dq-card:hover{border-color:rgba(255,45,149,.4);transform:translateY(-2px)}\
    .dq-card.selected{border-color:'+PINK+';background:#1f1a1d}\
    .dq-card-icon{width:48px;height:48px;border-radius:12px;background:rgba(255,255,255,.05);display:flex;align-items:center;justify-content:center;font-size:24px;margin-bottom:12px}\
    .dq-card-label{font-weight:700;font-size:14px;color:#fff;margin:0}\
    .dq-card-sub{color:#888;font-size:12px;margin:4px 0 0;line-height:1.4}\
    .dq-card-check{position:absolute;top:12px;right:12px;width:20px;height:20px;border-radius:50%;background:'+PINK+';display:flex;align-items:center;justify-content:center}\
    .dq-budget-box{max-width:480px;margin:0 auto;background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);border-radius:20px;padding:32px}\
    .dq-budget-row{display:flex;align-items:center;justify-content:space-between;margin-bottom:24px}\
    .dq-budget-label{text-align:center}\
    .dq-budget-label small{display:block;color:#888;font-size:11px;text-transform:uppercase;letter-spacing:.08em;margin-bottom:4px}\
    .dq-budget-label span{font-size:24px;font-weight:900;color:#fff}\
    .dq-budget-sep{flex:1;margin:0 24px;height:1px;background:rgba(255,255,255,.1)}\
    .dq-slider-group{margin-bottom:16px}\
    .dq-slider-group label{display:block;color:#888;font-size:12px;margin-bottom:8px}\
    .dq-slider{-webkit-appearance:none;appearance:none;width:100%;height:6px;border-radius:3px;background:#333;outline:none}\
    .dq-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:24px;height:24px;border-radius:50%;background:'+PINK+';cursor:pointer;border:3px solid #000;box-shadow:0 2px 8px rgba(255,45,149,.4)}\
    .dq-slider::-moz-range-thumb{width:24px;height:24px;border-radius:50%;background:'+PINK+';cursor:pointer;border:3px solid #000}\
    .dq-count{text-align:center;margin:24px 0;font-size:14px;color:#aaa}\
    .dq-count strong{color:#4ade80;font-size:18px}\
    .dq-submit{width:100%;padding:14px 24px;border-radius:12px;background:'+PINK+';color:#fff;font-weight:700;font-size:15px;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;transition:filter .15s}\
    .dq-submit:hover{filter:brightness(1.1)}\
    .dq-submit:disabled{opacity:.5;cursor:default}\
    .dq-back{display:flex;align-items:center;justify-content:center;gap:6px;color:#888;font-size:14px;margin-top:32px;cursor:pointer;background:none;border:none;transition:color .15s}\
    .dq-back:hover{color:#fff}\
    .dq-results{max-width:960px;margin:0 auto;padding:20px}\
    .dq-result-card{background:#1a1a1a;border-radius:16px;padding:20px;margin-bottom:16px;display:flex;gap:16px;align-items:center;border:1px solid #333;cursor:pointer;transition:border-color .15s}\
    .dq-result-card:hover{border-color:'+PINK+'}\
    .dq-result-img{width:100px;height:100px;border-radius:12px;object-fit:cover;background:#222;flex-shrink:0}\
    .dq-result-info{flex:1}\
    .dq-result-tier{display:inline-block;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.08em;padding:2px 8px;border-radius:6px;margin-bottom:6px}\
    .dq-result-tier.good{background:rgba(74,222,128,.15);color:#4ade80}\
    .dq-result-tier.better{background:rgba(96,165,250,.15);color:#60a5fa}\
    .dq-result-tier.best{background:rgba(255,45,149,.15);color:'+PINK+'}\
    .dq-result-title{font-weight:700;font-size:15px;color:#fff;margin:0 0 4px}\
    .dq-result-reason{color:#aaa;font-size:13px;margin:0 0 8px;line-height:1.4}\
    .dq-result-price{font-weight:900;font-size:18px;color:'+PINK+'}\
    .dq-result-actions{display:flex;gap:8px;margin-top:24px}\
    .dq-result-actions a{flex:1;text-align:center;padding:12px;border-radius:12px;font-weight:700;font-size:14px;text-decoration:none;transition:filter .15s}\
    .dq-result-actions a:hover{filter:brightness(1.1)}\
    .dq-btn-primary{background:'+PINK+';color:#fff}\
    .dq-btn-secondary{background:rgba(255,255,255,.08);color:#fff;border:1px solid rgba(255,255,255,.15)}\
    @media(max-width:600px){.dq-result-card{flex-direction:column;align-items:stretch}.dq-result-img{width:100%;height:160px}}\
  ';
  document.head.appendChild(style);

  var ICONS={
    me:'&#x1F9D1;',kid:'&#x1F476;',gift:'&#x1F381;',business:'&#x1F4BC;',browsing:'&#x1F50D;',
    school:'&#x1F4DA;',gaming:'&#x1F3AE;',writing:'&#x2709;',design:'&#x1F3A8;',
    'video editing':'&#x1F3AC;','first device':'&#x2B50;',family:'&#x1F46A;',
    broken:'&#x1F6A8;',outgrew:'&#x1F4C8;',gift_deadline:'&#x1F389;',
    first_device:'&#x2B50;',just_curious:'&#x1F914;'
  };

  function render(){
    var idx=stepOrder.indexOf(currentStep);
    var progress=((idx+1)/stepOrder.length)*100;

    var html='<div class="dq-progress"><div class="dq-progress-bar" style="width:'+progress+'%"></div></div>';
    html+='<div class="dq-pills">';
    for(var i=0;i<stepOrder.length;i++){
      var cls=i<idx?'done':i===idx?'active':'future';
      var check=i<idx?'<svg width="12" height="12" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/></svg>':'';
      html+='<div class="dq-pill '+cls+'">'+check+STEP_LABELS[i]+'</div>';
      if(i<stepOrder.length-1) html+='<div class="dq-pill-sep"></div>';
    }
    html+='</div>';

    html+='<div class="dq-content">';

    if(currentStep==='forWhom'){
      html+=renderCardStep('Who are we shopping for?','Tap a card to get started.',STEP_FOR_WHOM,forWhom);
    } else if(currentStep==='mainJob'&&forWhom){
      var jobs=stepMainJob(forWhom);
      var headline=forWhom==='kid'?"What'll they use it for?":forWhom==='business'?'What runs on it most?':"What'll you do most?";
      var subhead=forWhom==='kid'?'Pick the one they do most.':forWhom==='business'?"The job it has to nail.":'Pick the heaviest lift.';
      html+=renderCardStep(headline,subhead,jobs,mainJob);
    } else if(currentStep==='driver'){
      html+=renderCardStep("What's pushing it now?",'The reason for shopping today.',STEP_DRIVER,driver);
    } else if(currentStep==='budget'){
      html+=renderBudgetStep();
    }

    if(idx>0){
      html+='<button class="dq-back" onclick="window.__dqBack()"><svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg> Back</button>';
    }

    html+='</div>';
    root.innerHTML=html;
  }

  function renderCardStep(headline,subhead,cards,selectedVal){
    var h='<div class="dq-header"><h2>'+headline+'</h2><p>'+subhead+'</p></div>';
    h+='<div class="dq-grid">';
    for(var i=0;i<cards.length;i++){
      var c=cards[i];
      var sel=selectedVal===c.value;
      var icon=ICONS[c.value]||'\u{1F4BB}';
      h+='<div class="dq-card'+(sel?' selected':'')+'" onclick="window.__dqPick(\''+c.value+'\',\''+(c.family||'')+'\')">';
      h+='<div class="dq-card-icon">'+icon+'</div>';
      h+='<p class="dq-card-label">'+c.label+'</p>';
      h+='<p class="dq-card-sub">'+c.sub+'</p>';
      if(sel) h+='<div class="dq-card-check"><svg width="12" height="12" fill="none" stroke="#fff" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/></svg></div>';
      h+='</div>';
    }
    h+='</div>';
    return h;
  }

  function renderBudgetStep(){
    var h='<div class="dq-header"><h2>What\'s the budget feel like?</h2><p>Slide it - we\'ll show what fits.</p></div>';
    h+='<div class="dq-budget-box">';
    h+='<div class="dq-budget-row"><div class="dq-budget-label"><small>Min budget</small><span>$'+budgetMin.toLocaleString()+'</span></div><div class="dq-budget-sep"></div><div class="dq-budget-label"><small>Max budget</small><span>$'+budgetMax.toLocaleString()+'</span></div></div>';
    h+='<div class="dq-slider-group"><label>Minimum</label><input type="range" class="dq-slider" min="300" max="2500" step="50" value="'+budgetMin+'" oninput="window.__dqBudget(\'min\',this.value)"></div>';
    h+='<div class="dq-slider-group"><label>Maximum</label><input type="range" class="dq-slider" min="300" max="2500" step="50" value="'+budgetMax+'" oninput="window.__dqBudget(\'max\',this.value)"></div>';
    h+='<div class="dq-count">';
    if(inventoryCount===null) h+='Finding what fits your budget...';
    else if(inventoryCount>0) h+='<strong>'+inventoryCount+'</strong> '+(inventoryCount===1?'Mac':'Macs')+' available in your range';
    else h+='No exact matches - try widening your range.';
    h+='</div>';
    h+='<button class="dq-submit" onclick="window.__dqSubmit()"'+(submitting?' disabled':'')+'>'+
      (submitting?'<svg width="16" height="16" fill="none" viewBox="0 0 24 24" style="animation:spin 1s linear infinite"><circle opacity=".25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path opacity=".75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/></svg> Finding your Mac...':'Find my Mac &#x2192;')+'</button>';
    h+='</div>';
    return h;
  }

  function fetchInventoryCount(){
    if(fetchController) fetchController.abort();
    fetchController=new AbortController();
    inventoryCount=null;
    render();
    fetch(API+'/inventory-count?budgetMin='+budgetMin+'&budgetMax='+budgetMax,{signal:fetchController.signal})
      .then(function(r){return r.ok?r.json():null;})
      .then(function(d){if(d) inventoryCount=d.count||0; render();})
      .catch(function(){});
  }

  function showResults(picks){
    var html='<div class="dq-progress"><div class="dq-progress-bar" style="width:100%"></div></div>';
    html+='<div class="dq-results">';
    html+='<div class="dq-header" style="padding-top:24px"><h2>Here\'s what Rick picked for you</h2><p>Three Macs that match your answers, ranked by fit.</p></div>';

    for(var i=0;i<picks.length;i++){
      var p=picks[i];
      var tier=p.tier||['good','better','best'][i];
      var tierLabel=tier==='good'?'Solid pick':tier==='better'?'Sweet spot':'Top shelf';
      var price=p.retailWithCore||p.price||0;
      var handle=SLUG_TO_HANDLE[p.slug]||p.slug;
      var productUrl='/products/'+handle;
      var imgUrl='https://lc-next.pages.dev/mac/'+p.slug+'/1.webp';

      html+='<a href="'+productUrl+'" class="dq-result-card" style="text-decoration:none">';
      html+='<img class="dq-result-img" src="'+imgUrl+'" alt="'+esc(p.title||p.model||p.slug)+'" onerror="this.style.display=\'none\'">';
      html+='<div class="dq-result-info">';
      html+='<span class="dq-result-tier '+tier+'">'+tierLabel+'</span>';
      html+='<p class="dq-result-title">'+(p.title||p.model||p.slug)+'</p>';
      html+='<p class="dq-result-reason">'+(p.reason||'')+'</p>';
      if(price) html+='<span class="dq-result-price">$'+price.toLocaleString()+'</span>';
      html+='</div>';
      html+='</a>';
    }

    html+='<div class="dq-result-actions">';
    html+='<a href="'+SHOP+'" class="dq-btn-secondary">Browse all Macs</a>';
    html+='<a href="javascript:void(0)" onclick="window.__dqRestart()" class="dq-btn-secondary">Start over</a>';
    html+='</div>';
    html+='</div>';
    root.innerHTML=html;
  }

  function esc(s){return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');}

  // Global handlers
  window.__dqPick=function(value,family){
    if(currentStep==='forWhom'){
      forWhom=value;
      setTimeout(function(){currentStep='mainJob';render();},200);
    } else if(currentStep==='mainJob'){
      mainJob=value;
      jobFamily=family||null;
      setTimeout(function(){currentStep='driver';render();},200);
    } else if(currentStep==='driver'){
      driver=value;
      setTimeout(function(){currentStep='budget';fetchInventoryCount();},200);
    }
  };

  window.__dqBudget=function(which,val){
    val=Number(val);
    if(which==='min'){
      budgetMin=val;
      if(budgetMax<val+50) budgetMax=Math.min(val+50,2500);
    } else {
      budgetMax=val;
      if(budgetMin>val-50) budgetMin=Math.max(val-50,300);
    }
    fetchInventoryCount();
  };

  window.__dqSubmit=function(){
    if(submitting) return;
    submitting=true;
    render();
    var body={
      use:mainJob||'browsing',
      family:jobFamily||'laptop',
      budgetMin:budgetMin,
      budgetMax:budgetMax,
      budget:budgetMax,
      driver:driver||'just_curious',
      forWhom:forWhom||'me'
    };
    fetch(API+'/recommend',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify(body)
    })
    .then(function(r){return r.json();})
    .then(function(data){
      submitting=false;
      var picks=data.picks||[];
      if(picks.length>=3){
        showResults(picks);
      } else {
        window.location.href=SHOP;
      }
    })
    .catch(function(){
      submitting=false;
      window.location.href=SHOP;
    });
  };

  window.__dqBack=function(){
    var idx=stepOrder.indexOf(currentStep);
    if(idx>0){
      currentStep=stepOrder[idx-1];
      render();
    }
  };

  window.__dqRestart=function(){
    currentStep='forWhom';forWhom=null;mainJob=null;jobFamily=null;driver=null;
    budgetMin=300;budgetMax=1500;inventoryCount=null;submitting=false;
    render();
  };

  // Spin animation
  var spinStyle=document.createElement('style');
  spinStyle.textContent='@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}';
  document.head.appendChild(spinStyle);

  render();
})();
